module.exports = __webpack_public_path__ + "static/media/Apu Nahasapeemapetilon.31021d17.png";